<template>
  <div class="text-center">
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'LoadingComponent',
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      loading: 'loading'
    })
  }
  // methods: {
  //     start() {
  //         this.$store.commit("on");
  //     },
  //     finish() {
  //         this.$store.commit("off");
  //     },
  // }
}
</script>
